NtechApp.AccountSearchForm = function($searchInput, resizeCb) {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._$searchInput = null;
    this._searchAuto = null;

    this._resizeCb = null;

    this._construct = function() {
        me._$searchInput = $searchInput;
        me._resizeCb = (typeof(resizeCb) == "function") ? resizeCb : NtechApp.noop;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._createAutocomplete();
        me._bindSearchAutoEvents();

        setTimeout(function() { me._resizeCb(); }, 100);
        me._bindEvents();
    }

    this._bindEvents = function() {
        $(window).on(NtechApp.AccountSearchForm.EVENT_WINDOW_RESIZE, function() {
            me._resizeCb();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.AccountSearchForm.EVENT_WINDOW_RESIZE = "resize.NtechApp.AccountSearchForm";

NtechApp.proto(NtechApp.AccountSearchForm, {
    getSearchAuto: function() {
        return this._searchAuto;
    },

    _createAutocomplete: function() {
        var me = this;

        me._searchAuto = new NtechApp.Autocomplete(
            me._$searchInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {
                    matchType: NtechApp.Autocomplete.MATCH_TYPES.FULL,
                    showMatchesClass: "searchMatches",
                    getWidth: function ($input) { return $input.outerWidth(); }
                }
            ),
            function() {
                me._loadSearchResults.apply(me, arguments);
            }
        );
        //me._searchAuto.setModalCss();
    },

    _bindSearchAutoEvents: function() {
        var me = this;

        // $(me._searchAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, data) {
        //     ;
        // });

        me._click.listen(me._searchAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadSearchResults(
                me._searchAuto.getSearchVal(),
                NtechApp.bind("appendData", me._searchAuto),
                NtechApp.noop,
                page
            );
        });
    },

    _getSearchRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_account_search';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_account_search';
    },

    _loadSearchResults: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;

        var params = {
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate(me._getSearchRoute(), params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            }
        });
    }
});